'use client'

import { Tooltip as RedesignTooltip, TooltipTextOverflow } from '@systemeio/components'
import { useState, type ComponentProps, type ReactNode } from 'react'

type TooltipMode = 'hover' | 'overflow'

interface TooltipProps {
  children: ReactNode
  disabled?: boolean
  label: ReactNode
  mode?: TooltipMode
  triggerProps?: ComponentProps<typeof RedesignTooltip>['triggerProps']
}

function Tooltip({
  children,
  disabled = false,
  label,
  mode = 'hover',
  triggerProps,
}: TooltipProps) {
  const [open, setOpen] = useState(false)

  if (mode === 'overflow') {
    return <TooltipTextOverflow tooltipContent={label}>{children}</TooltipTextOverflow>
  }

  return (
    <RedesignTooltip
      open={disabled ? false : open}
      onOpenChange={value => {
        if (!disabled) setOpen(value)
      }}
      content={label}
      trigger={children}
      triggerProps={{ render: <div />, ...triggerProps }}
    />
  )
}

export { Tooltip }
export type { TooltipMode, TooltipProps }
